module.exports = __webpack_public_path__ + "img/3taskStatus.8a288521.svg";